// @flow

import Service from './service';
import type { IfpAppType } from '../types/ifp-app';
import type { HttpResponseType } from '../types/http-response';

export default class EmailService extends Service {
  requestChange(options: Object = {}): Promise<Array<IfpAppType>> {
    return this.api.post(`${this.baseUrl}/email/change-request`, options)
      .then((res: HttpResponseType) => (res.data: Array<IfpAppType>));
  }

  subscribe(body: { email: string, lists: Array<string> }, options: Object = {}): Promise<boolean> {
    return this.api.post(`${this.baseUrl}/subscribe/email`, body, options)
      .then(() => true)
      .catch(() => false);
  }
}
